window.app.controller("educationCtrl", [
    "$scope",
    "$http",
    "$compile",
    "$sce",
    function ($scope, $sce, $http, $compile, $timeout, $q, $log) {
        
        $scope.model = {
            search: "",
            isPaid: "",
            categoryId: "",
            languageId: "1",
            start: 0,
            limit: 10,
          };
          

        $scope.screenWidth = function () {
            if (window.screen.width >= 730) {
              $scope.isDesktop = true;
            } else {
              $scope.isMobile = true;
            }
          };

        $scope.toggleFilters = function () {
            $scope.showFilters = !$scope.showFilters;
      
        };

        //rest for category
        $scope.getCategories = function () {
            $scope.sendXHR({
              url: `https://ekassa.eu/racoon/training/getCategories`,
              method: "GET",
              headers: { Authorization: "Basic aW52ZXN0OmtzYmY7YSVmc2xsc2dAcQ==" },
              dataAsParam: false,
              successFunc: function success(response) {
                $scope.categories = response.data;
              },
            });
        };
        $scope.getCategories();

        //rest for language
        $scope.getLanguage = function () {
            $scope.sendXHR({
              url: `https://ekassa.eu/racoon/training/getLanguages`,
              method: "GET",
              headers: { Authorization: "Basic aW52ZXN0OmtzYmY7YSVmc2xsc2dAcQ==" },
              dataAsParam: false,
              successFunc: function success(response) {
                $scope.languagies = response.data;
              },
            });
        };
        $scope.getLanguage();

        //reat for offers
        $scope.getCourses = function (pagination) {
            let headers = new Headers();
      
            if (pagination === false) {
              $scope.currentPage = 0;
              $scope.model.start = 0;
            }
            headers.append("Content-Type", "application/json");
            headers.append("Authorization", "Basic aW52ZXN0OmtzYmY7YSVmc2xsc2dAcQ==");
            $scope.sendXHR({
              url: `https://ekassa.eu/racoon/training/getTrainingOffers`,
              method: "GET",
              params: $scope.model,
              headers: { Authorization: "Basic aW52ZXN0OmtzYmY7YSVmc2xsc2dAcQ==" },
              dataAsParam: false,
              successFunc: function success(response) {
                $scope.courses = response.data.data.trainingOfferDtos;
                $scope.countCourses = response.data.data.count;
      
                $scope.numberOfPages = Math.ceil($scope.countCourses / $scope.model.limit);
              },
            });
            window.scrollTo({ top: 0, behavior: 'smooth' });
          };
          $scope.getCourses(false);

        $scope.changePage = function (pageNumber) {
            $scope.currentPage = pageNumber;
            $scope.model.start = $scope.model.limit * pageNumber;
            $scope.getCourses(true);
          }
      
        $scope.currentPage = 0;
        $scope.model.limit = 10;

        
        $scope.prices = [
            {
                type: "free",
                value: false
            },
            {
                type: "not free",
                value: true
            },
        ]

},
]);



// WEBPACK FOOTER //
// src/js/controllers/offers/finOffers/educationCtrl.js